export const h1 = {
  id: 1,
  title: "PEACE",
  subtitle: "WARSAW HOTEL",
  details: {
    type: "academic course project",
    date: "11-2021",
    "final grade": "5 out of 5",
  },
  splits: [
    {
      img: "Hotel/1/Site plan.jpg",
      desc: [
        "Hotel's architecture has been shaped by two key design decisions - a wooden structure and creation of a peaceful atmosphere in the centre of Warsaw. These dominant factors, along with the preliminary analysis, inspired all further outcomes in the matter of shape, structure and interior design of the hotel.",
      ],
    },
    {
      img: "Hotel/1/Exterior view.jpg",
      imgSm: "Hotel/1/Wooden construction axonometry.jpg",
      desc: [
        "The wooden structure of such a tall building required research and carefull planning. Wide columns and braces extending through the interior remained exposed and formed the basis for building aesthetic quality. Moreover, the tectonics of the structure on the façade of the main tower was visually enhanced by overhangs and green terraces.",
      ],
    },
    {
      img: "Hotel/1/First floor plan.jpg",
      imgSm: "Hotel/1/Zones.jpg",

      desc: [
        "To create an intimate atmosphere on the patio, the plan has been divided into three hexagonal segments. In the centre of each, open space was created. Two of then were covered with a glass roof. The one in the east wing includes a foyer with a winter garden, another one places a garden, and the last a SPA swimming pool. In addition, the hotel contains a restaurant with full facilities, a Fitness and SPA zone, conference rooms, and 157 apartments ranging from economy to larger suites.",
      ],
    },
    {
      img: "Hotel/1/Patio view.jpg",
      imgSm: "Hotel/1/Patio axonometry.jpg",
    },
    {
      img: "Hotel/1/SPA axonometry.jpg",
      imgSm: "Hotel/1/Apartment-floor axonometry.jpg",
    },
  ],
  bigImgs: [],
  imgs: [],
};
export const h2 = {
  id: 2,
  title: "GREEN VIEW",
  subtitle: "HOTEL „TARGOWA”",
  details: {
    type: "academic course project",
    date: "11-2021",
    "final grade": "5 out of 5",
  },
  splits: [
    {
      img: "Hotel/2/Second floor plan.jpg",
      imgSm: "Hotel/2/Zones.jpg",

      desc: [
        "The hotel building is an architectural infill between the existing tenement houses. In front of the main façade, there is a historic Łódź Park, Źródliska, known among the inhabitants for its industrial history.",
        "The glazed front elevation allows to open a lounge on the ground floor, a restaurant on the first floor and hotel rooms on the other floors with a view of greenery. To strengthen this connection, each floor has extensive, rounded balconies.",
        "The shape of the building and balconies has been designed to protect the existing high greenery on the plot. In this way, the curving façade flows around the trees, further connecting the plot to the park.",
        "In the backyard there are parking lots and two garden terazzes with a quiet space to rest",
      ],
    },
  ],

  bigImgs: ["Hotel/2/Image.jpg"],
};
